export class CarouselHelperService {
  /**
   * Method calculates the number of slides to be displayed
   */
  countSlidesToDisplay(width: number, buttonWidth: number, slideWidth: number): number {
    return Math.trunc((width - buttonWidth * 2) / slideWidth);
  }
}
